// extracted by mini-css-extract-plugin
export default {"helperText":"inputtext_helperText__20gTl"};